var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region CourseRegistrationAttendance - ctor
    ns.CourseRegistrationAttendance = function CourseRegistrationAttendance(courseRegistrationAttendanceDTO) {
        this.courseScheduleID = courseRegistrationAttendanceDTO.courseScheduleID;
        this.startDate = courseRegistrationAttendanceDTO.startDate;
        this.endDate = courseRegistrationAttendanceDTO.endDate;
        this.courseAttendanceType = courseRegistrationAttendanceDTO.courseAttendanceType;
        this.courseAttendanceStatus = courseRegistrationAttendanceDTO.courseAttendanceStatus;

        // Save old values
        this.oldCourseAttendanceType = courseRegistrationAttendanceDTO.courseAttendanceType;
        this.oldCourseAttendanceStatus = courseRegistrationAttendanceDTO.courseAttendanceStatus;

        this.attendanceNotes = courseRegistrationAttendanceDTO.attendanceNotes;
        this.attendanceCount = courseRegistrationAttendanceDTO.attendanceCount || 1;

        // Link to User schedule for calculation of free places for whole user (client section registration)
        this.$courseRegistrationUserSchedule = null;

        this.$hasError = false;
    };
    // #endregion



    // #region CourseRegistrationAttendance - Properties
    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'isRegistered', {
        enumerable: true, configurable: true,
        get: function () {
            return this.courseAttendanceType === 0;
        },
        set: function (value) {
            if (value) {
                if (this.oldCourseAttendanceType === 0) {
                    this.courseAttendanceType = this.oldCourseAttendanceType;
                    this.courseAttendanceStatus = this.oldCourseAttendanceStatus;

                } else {
                    this.courseAttendanceType = 0;
                    this.courseAttendanceStatus = 0;
                }
            } else {
                if (this.oldCourseAttendanceType !== 0) {
                    this.courseAttendanceType = this.oldCourseAttendanceType;
                    this.courseAttendanceStatus = this.oldCourseAttendanceStatus;
                } else {
                    this.courseAttendanceType = null;
                    this.courseAttendanceStatus = null;
                }
            }
        }
    });

    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'isDisabled', {
        enumerable: true, configurable: true,
        get: function () {
            var dis = this.courseAttendanceType === 1 ||
                      this.courseAttendanceType === 2 ||
                      this.courseAttendanceType === 3;

            if (this.$courseRegistrationUserSchedule) {
                dis = dis || (this.$courseRegistrationUserSchedule.freePlaces === 0 && !this.isRegistered);
            }

            return dis;
        }
    });

    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'isInThePast', {
        enumerable: true, configurable: true,
        get: function () {
            return moment(this.startDate).isBefore(moment());
        }
    });

    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'isUserEditable', {
        enumerable: true, configurable: true,
        get: function () {
            return !this.isInThePast && !this.isDisabled;
        }
    });

    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'hasChanged', {
        enumerable: true, configurable: true,
        get: function () {
           
            return (this.oldCourseAttendanceType !== this.courseAttendanceType) ||
                   (this.oldCourseAttendanceStatus !== this.courseAttendanceStatus);
        }
    });

    Object.defineProperty(ns.CourseRegistrationAttendance.prototype, 'freePlaces', {
        enumerable: true, configurable: true,
        get: function () {
            if (this.$courseRegistrationUserSchedule) {
                return this.$courseRegistrationUserSchedule.freePlaces;
            }

            return 0;
        }
    });

    // #endregion

    ns.CourseRegistrationAttendance.prototype.toJSON = function () {
        return {
            courseScheduleID: this.courseScheduleID,
            startDate: this.startDate,
            endDate: this.endDate,
            courseAttendanceType: this.courseAttendanceType,
            courseAttendanceStatus: this.courseAttendanceStatus,
            attendanceNotes: this.attendanceNotes
        }
    }

    ns.CourseRegistrationAttendance.prototype.setUserScheduleBinding = function(courseRegistrationUserSchedule) {
        this.$courseRegistrationUserSchedule = courseRegistrationUserSchedule;
    }

    ns.CourseRegistrationAttendance.prototype.updateCapacityByRefreshedSchedule = function (schedule) {
        if (!this.$courseRegistrationUserSchedule || !schedule) {
            return;
        }

        this.$courseRegistrationUserSchedule.origCapacity = schedule.capacity;
        this.$courseRegistrationUserSchedule.origFilled = schedule.filled;

        if (this.$hasError && this.isRegistered && this.isUserEditable) {
            this.isRegistered = false;
        }
    }

})(webooker_courses_models);